/*
 * Product FAQ (sections/product-faq.liquid)
 * <details> rows work without JS; this adds a smooth height animation and the
 * "only one open at a time" option, and opens a question selected in the theme editor.
 */
if (!customElements.get('product-faq')) {
  customElements.define(
    'product-faq',
    class ProductFaq extends HTMLElement {
      connectedCallback() {
        this.single = this.dataset.single === 'true';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelectorAll('.product-faq__item').forEach((item) => {
          item.querySelector('summary').addEventListener('click', (event) => {
            event.preventDefault();
            this.toggle(item, !item.open);
          });
        });
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.product-faq__item');
          if (item && !item.open) this.toggle(item, true);
        });
      }

      toggle(item, open) {
        if (open && this.single) {
          this.querySelectorAll('.product-faq__item[open]').forEach((other) => {
            if (other !== item) this.animate(other, false);
          });
        }
        this.animate(item, open);
      }

      animate(item, open) {
        const panel = item.querySelector('.product-faq__answer');
        if (item.animation) item.animation.cancel();
        if (this.reduceMotion || !panel.animate) {
          item.open = open;
          return;
        }
        const start = open ? 0 : panel.offsetHeight;
        if (open) item.open = true;
        const end = open ? panel.scrollHeight : 0;
        item.animation = panel.animate(
          [{ height: start + 'px' }, { height: end + 'px' }],
          { duration: 250, easing: 'ease' }
        );
        item.animation.onfinish = () => {
          item.animation = null;
          if (!open) item.open = false;
        };
        item.animation.oncancel = () => {
          item.animation = null;
        };
      }
    }
  );
}
